import Layout from "@/components/Layout";

// Converted from about.php by scripts/convert-php-pages.mjs.
export default function PageAbout() {
  return (
    <Layout route="/about">
      <>
<div className="about-area pt-100 pb-70">
<div className="container">
<div className="row align-items-center">
<div className="col-lg-6">
<div className="about-item">
<div className="about-left">
<img src="/assets/img/drim.png" alt="About" />
</div>
</div>
</div>
<div className="col-lg-6">
<div className="about-item about-right">
<img src="/assets/img/home-one/5.png" alt="About" />
<h1>Dr. Parveen Yadav<br /><span style={{ fontSize: "12px" }}>(Director, Thoracic and Robotic Surgeries and Surgical Oncology)</span></h1>
<p>Dr Parveen Yadav is a Surgical Oncologist for thoracic surgeries in Delhi NCR. Years of practice and experience have earned him the reputation of one of the most respected and trusted surgeons across India. </p> <p>Dr Yadav holds MBBS and MS General Surgery degrees from the esteemed Pt BD Sharma Medical College, Rohtak. He has also been trained in Surgical Oncology for 3 years at the Institute Rotary Cancer Hospital (IRCH) AIIMS, New Delhi. Dr Yadav is a super-specialist in thoracic surgery who has also done a 2-year Thoracic Surgery Fellowship from the prestigious Tata Memorial Hospital, Mumbai.
    </p>
<ul>
<li>
<i className="icofont-check-circled"></i>
    Designation:- Chief and Senior Consultant, Thoracic Surgery and Surgical Oncology
    </li>
<li>
<i className="icofont-check-circled"></i>
    Experience:- 18+ years in Minimally Invasive Thoracic and Robotic Onco Surgeries
    </li>
<li>
<i className="icofont-check-circled"></i>
    Address:- Artemis Hospital, Sector 51, Gurgaon – Haryana
    
    </li>
</ul>
</div>
</div>
<div className="col-md-12">
<p>Dr Parveen Yadav has created his niche in the Indian healthcare sector by making the most of modern technology in treating his patients. He has cracked the code to obtain an ideal balance between technological advancements and his knowledge of the domain. Performing thoracic surgeries in Delhi NCR, Dr Yadav has given several patients a new lease on life.
            <br />
    
    
            The thoracic surgeon in Gurgaon specializes in Minimally Invasive and Robotic Lung and Esophageal surgeries. He is known for treating cancers and other diseases in the lungs and esophagus (food pipe). His other areas of expertise include mediastinal diseases, airway diseases, interventional bronchoscopy, and soft tissue sarcoma. <br />With 18+ years of experience in Oncology and 12+ years of experience in Thoracic Surgery, Dr Yadav has performed more than 5,700 major thoracic procedures. These procedures include over 1,000 surgeries for esophageal cancer and other esophageal diseases. He has also performed over 1,000 surgeries for lung cancer treatment and other lung diseases.</p>
<p>Dr Yadav is trained in performing minimally invasive and robotic surgeries to provide the outcomes for his patients, helping them restore their bodies’ normalcy. He has mastered video-assisted thoracoscopic surgery (VATS) to diagnose and treat cancer and other diseases in the thoracic region. Throughout his tenure as a respected thoracic surgeon in Delhi NCR, he has been successful in treating complicated lung and pleural diseases, including <a href="/empyema-treatment-gurgaon">Empyema</a>, <a href="/bronchopleural-fistula-treatment-gurgaon">Bronchopleural Fistula</a>, Tuberculosis, <a href="/bullous-disease">Bullous Disease</a>, Thymomas, <a href="/mediastinal-tumor-treatment-gurgaon">Mediastinal Mass</a>, <a href="/chest-wall-tumor-surgery-gurgaon">Chest Wall Tumor</a>, and more. </p> <p>Dr Parveen Yadav has been associated with some of the topmost medical institutions in India, including the All India Medical Institute of Medical Sciences (AIIMS) New Delhi, Tata Memorial Hospital (Mumbai), Artemis Hospital (Gurgaon), Sri Ganga Ram Hospital (New Delhi), Paras Hospital (Gurgaon), Fortis Hospital (Noida), Asian Institute (Faridabad).
    </p>
</div>
<ul>
<li>
<i className="icofont-check-circled"></i>
    MBBS, MS (General Surgery), FAIS, FAIGES
    </li>
<li>
<i className="icofont-check-circled"></i>
    Surgical Oncology (AIIMS)
    </li>
<li>
<i className="icofont-check-circled"></i>
    HBNI Fellowship in Thoracic Surgery (TATA Memorial Hospital, Mumbai)
    </li>
<li>
<i className="icofont-check-circled"></i>
    Da Vinci certified trained Robotic Surgeon
    </li>
</ul>
<h2>MEMBERSHIP</h2>
<p>Some of the most noteworthy memberships of Dr Yadav include:
    </p>
<ul>
<li><a href="https://asiindia.org/">Association of Surgeons in India (ASI) </a>   </li>
<li><a href="https://www.iages.in/">Association for Gastrointestinal Endoscopic Surgeons of India (IAGES) </a>  </li>
<li><a href="https://www.palliativecare.in/">Indian Association for Palliative Care </a></li>
</ul>
<h2>Procedures</h2>
<p>Here are some of the major procedures Dr Parveen Yadav excels in:</p>
<ul>
<li>Minimally invasive surgeries to treat esophageal cancer and other esophageal diseases</li>
<li>Minimally invasive thoracic surgeries for treating lung cancer</li>
<li>Minimally invasive surgeries to treat benign lung diseases, such as lung volume reduction surgery (LVRS), bullous disease, bronchopleural fistula, pneumothorax, etc.</li>
<li>Complex surgeries to treat airway diseases, such as tracheal tumors, trachea-esophageal fistula, etc.</li>
<li>Minimally invasive surgeries to treat pleural diseases, such as pleural tumors, empyema, pleural biopsy, etc.</li>
<li>Minimally invasive surgeries to treat mediastinal diseases, such as mediastinal masses and cysts</li>
<li>Complex surgeries for chest wall and sternum resection and reconstruction</li>
<li>Diagnostic and therapeutic mediastinoscopy</li>
<li>Stenting and therapeutic intervention bronchoscopy</li>
</ul>
</div>
</div>
</div>
<div className="counter-area counter-bg counter-area-four">
<div className="container">
<div className="row">
<div className="col-sm-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-patient-bed"></i>
<h3>
<span className="odometer" data-count="850">00</span>
</h3>
<p>Patients Beds</p>
</div>
</div>
<div className="col-sm-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-people"></i>
<h3>
<span className="odometer" data-count="2500">00</span>
<span className="target">+</span>
</h3>
<p>Happy Patients</p>
</div>
</div>
<div className="col-sm-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-doctor-alt"></i>
<h3>
<span className="odometer" data-count="750">00</span>
</h3>
<p>Doctors & Nurse</p>
</div>
</div>
<div className="col-sm-6 col-md-3 col-lg-3">
<div className="counter-item">
<i className="icofont-badge"></i>
<h3>
<span className="odometer" data-count="20+">00</span>
</h3>
<p>Year Experience</p>
</div>
</div>
</div>
</div>
</div>
<section className="speciality-area pb-100">
<div className="container-fluid p-0">
<div className="row m-0">
<div className="col-lg-7">
<div className="speciality-left">
<div className="section-title-two">

<h2>Honours and Rewards</h2>
</div>
<div className="speciality-item">
<div className="row m-0">
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".3s">
<div className="speciality-inner">
<i className="icofont-check-circled"></i>
<p><strong>Guest Faculty in Various National  & International Conferences.</strong></p>
</div>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".5s">
<div className="speciality-inner">
<i className="icofont-check-circled"></i>
<p><strong>Chair Person for Various National & International Conferences</strong></p>
</div>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".3s">
<div className="speciality-inner">
<i className="icofont-check-circled"></i>
<p><strong>Poster Award, Indian Cancer Congress, 2011</strong></p>
</div>
</div>
<div className="col-sm-6 col-lg-6 wow fadeInUp" data-wow-delay=".5s">
<div className="speciality-inner">
<i className="icofont-check-circled"></i>
<p><strong>Organized various National & Regional Conferences. (ASICON 2015,FIAGES 2017)</strong></p>
</div>
</div>
</div>
</div>
</div>
</div>
<div className="col-lg-5 pr-0">
<div className="speciality-item speciality-right">
<img src="/assets/img/home-two/8.jpg" alt="Speciality" />
<div className="speciality-emergency">
<div className="speciality-icon">
<i className="icofont-ui-call"></i>
</div>
<h3>Call for Appointments</h3>
<p>+91 9540210956</p>
</div>
</div>
</div>
</div>
</div>
</section>
<section className="services-area pb-50">
<div className="container">
<div className="section-title">
<h2>Treatment Options</h2>
</div>
<div className="row">
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".3s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/esc.png" alt="Treatment Options" />
<h3>Esophageal Diseases</h3>
<p>Esophageal cancer and other diseases that affect the patient’s food pipe<br /><br /></p>
</div>
<div className="service-end">
<img src="/assets/img/esc.png" alt="Esophageal Diseases" />
<h3>Esophageal Diseases</h3>
<p>Esophageal cancer and other diseases that affect the patient’s food pipe<br /><br /></p>
<a href="/esophageal-cancer-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".5s">
<div className="service-item">
<div className="service-front">
<i className="icofont-lungs"></i>
<h3>Lung Diseases</h3>
<p>Lung cancer and other diseases affecting the overall lung health<br /><br /></p>
</div>
<div className="service-end">
<i className="icofont-lungs"></i>
<h3>Lung Diseases</h3>
<p>Lung cancer and other diseases affecting the overall lung health<br /><br /></p>
<a href="/lungs-cancer-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".7s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/trach.png" alt="Tracheal Diseases" />
<h3>Tracheal Diseases</h3>
<p>Cancer and other complications in the patient’s tracheal region<br /><br /></p>
</div>
<div className="service-end">
<img src="/assets/img/trach.png" alt="Tracheal Diseases" />
<h3>Tracheal Diseases</h3>
<p>Cancer and other complications in the patient’s tracheal region<br /><br /></p>
<a href="/tracheal-cancer-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".9s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/chestwall.png" alt="Chest Wall Diseases" />
<h3>Chest Wall Diseases</h3>
<p>Cancer and complications in the patient’s chest wall, the protective structure between the neck and abdomen <br /><br /></p>
</div>
<div className="service-end">
<img src="/assets/img/chestwall.png" alt="Chest Wall Diseases" />
<h3>Chest Wall Diseases</h3>
<p>Cancer and complications in the patient’s chest wall, the protective structure between the neck and abdomen<br /><br /> </p>
<a href="/chest-wall-tumor-surgery-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".3s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/medi.png" alt="Mediastinal Mass" />
<h3>Mediastinal Mass</h3>
<p>Tumor caused by the masses of cells accumulating in the space between your lungs<br /><br /> </p>
</div>
<div className="service-end">
<img src="/assets/img/medi.png" alt="Mediastinal Mass" />
<h3>Mediastinal Mass</h3>
<p>Tumor caused by the masses of cells accumulating in the space between your lungs<br /><br /> </p>
<a href="/mediastinal-tumor-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".5s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/empm.png" alt="Empyema" />
<h3>Empyema</h3>
<p>Pockets of pus forming in the patient’s pleural space<br /><br /></p>
</div>
<div className="service-end">
<img src="/assets/img/empm.png" alt="Empyema" />
<h3>Empyema</h3>
<p>Pockets of pus forming in the patient’s pleural space<br /><br /></p>
<a href="/empyema-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".7s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/fistula.png" alt="Bronchopleural Fistula" />
<h3>Bronchopleural Fistula</h3>
<p>An abnormal passageway between the bronchial tubes and pleural space in the lungs</p>
</div>
<div className="service-end">
<img src="/assets/img/empm.png" alt="Bronchopleural Fistula" />
<h3>Bronchopleural Fistula</h3>
<p>An abnormal passageway between the bronchial tubes and pleural space in the lungs</p>
<a href="/bronchopleural-fistula-treatment-gurgaon">Read More</a>
</div>
</div>
</div>
<div className="col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay=".9s">
<div className="service-item">
<div className="service-front">
<img src="/assets/img/bulliou.png" alt="shaps" />
<h3>Bullous Disease</h3>
<p>A skin condition resulting in large and fluid-filled blisters<br /><br /></p>
</div>
<div className="service-end">
<img src="/assets/img/bulliou.png" alt="shaps" />
<h3>Bullous Disease</h3>
<p>A skin condition resulting in large and fluid-filled blisters<br /><br /></p>
<a href="/bullous-disease">Read More</a>
</div>
</div>
</div>
</div>
</div>
</section>

      </>
    </Layout>
  );
}
